import type { IFlightLegSummary } from '../../types/flight';

export default ({ layovers, airports }: IFlightLegSummary): boolean => layovers.length < airports.length - 2;
